import { StandardDonationAasmState } from '@types'
import flagIconRaw from '@/assets/flag.svg?raw'
import checkDoubleIconRaw from '@/assets/check-double.svg?raw'
import xIconRaw from '@/assets/x.svg?raw'
import jobIconRaw from '@/assets/job.svg?raw'
import styles from '../Map.module.scss'

// Add class to SVG strings
const addClassToSvg = (svg: string, className: string): string =>
  svg.replace('<svg', `<svg class="${className}"`)

const flagIcon = addClassToSvg(flagIconRaw, styles.markerIcon)
const checkDoubleIcon = addClassToSvg(checkDoubleIconRaw, styles.markerIcon)
const xIcon = addClassToSvg(xIconRaw, styles.markerIcon)
const jobIcon = addClassToSvg(jobIconRaw, styles.markerIcon)

interface MarkerConfig {
  icon: string
  pinClass: string
  badgeClass?: string
}

const getMarkerConfig = (
  status: 'dispatch' | 'return' | StandardDonationAasmState
): MarkerConfig => {
  if (status === 'dispatch' || status === 'return') {
    return {
      icon: flagIcon,
      pinClass: styles.markerDispatch,
      badgeClass: styles.markerBadgeGray,
    }
  }

  if (status === StandardDonationAasmState.COMPLETED) {
    return {
      icon: checkDoubleIcon,
      pinClass: styles.markerCompleted,
    }
  }

  if (
    status === StandardDonationAasmState.CANCELED ||
    status === StandardDonationAasmState.DECLINED
  ) {
    return {
      icon: xIcon,
      pinClass: styles.markerCanceled,
    }
  }

  return {
    icon: jobIcon,
    pinClass: styles.markerDefault,
  }
}

export const createMarkerHtml = (
  stepNumber: number,
  status: 'dispatch' | 'return' | StandardDonationAasmState,
  showBadge: boolean
): string => {
  const config = getMarkerConfig(status)

  const badgeClass = config.badgeClass
    ? `${styles.markerBadge} ${config.badgeClass}`
    : styles.markerBadge

  const badgeHtml = showBadge
    ? `<div class="${badgeClass}">${stepNumber}</div>`
    : ''

  return `
    <div class="${styles.markerWrapper}">
      ${badgeHtml}
      <div class="${styles.markerPin} ${config.pinClass}">
        ${config.icon}
      </div>
      <div class="${styles.markerTail} ${config.pinClass}"></div>
    </div>
  `
}
